import React, { Component } from 'react'

class ToggleCounter extends Component {
  state = {
      count: 0
  };

  componentDidMount() {
      console.log("ToggleCounter mounted");
      // this.interval is like a state, this can be used inside any component
      // we made this.interval so that we can use interval in other component also.
      // when a state is changed, render method is called, but on changing this render method will not called
      this.interval = setInterval(() => {
          this.setState({
              count: this.state.count + 1
          });
      }, 10000);
  }

  componentWillUnmount() {
    console.log("ToggleCounter un-mounted");
    //not setting clear interval will show error
    clearInterval(this.interval);
  }

  render() {
      const { count } = this.state;

    return (
      <>
        {count}
        <br/>
      </>
    );
  }
}

export default ToggleCounter;
